import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { Spacer } from "@Components/Space"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import React, { useEffect, useState } from "react"
import { StyleSheet, TouchableOpacity, View } from "react-native"
import { Checkbox } from "react-native-paper"
import { handleSetCheckBoxResponsesPayload } from "./QuestionLogic"
import CustomCheckBox from "@Components/CustomCheckBox/CustomCheckBox"

export const QuestionWithCheckBox = (props) => {
    const { question, responses, questionId, setPayload, isResult, userResponse, questionNumber } = props
    const [checked, setChecked] = useState([0])
    const handleCheck = (responseId) =>
        handleSetCheckBoxResponsesPayload({ questionId, responseId, setPayload, setChecked })

    const checkBoxItems = Array.from(responses, (item) => ({
        id: item.id,
        label: item.textResponse,
        checked: item.isTrue
    }))

    useEffect(() => {
        if (isResult) {
            setChecked(userResponse?.userResponse)
        } else {
            setChecked([0])
        }
    }, [userResponse, isResult])

    const correctAnswer = responses.filter((res) => userResponse?.correctResponse?.includes(res.id))

    return (
        <View style={{ marginBottom: 50 }}>
            <OpenSansText fontWeight="bold" color={baseColors.orange.primary}>{`QUESTION N° ${
                questionNumber ?? 1
            }`}</OpenSansText>
            <OpenSansText style={{ marginTop: 10 }} fontSize={14}>
                {question ?? "Quel est le rôle essentiel des glucides dans l’organisme ?"}
            </OpenSansText>

            <Spacer height={20} />

            <View style={{}}>
                {checkBoxItems.map((item) => (
                    <TouchableOpacity
                        disabled={isResult}
                        onPress={() => handleCheck(item.id)}
                        style={styles.checkBox}
                        key={item.id}
                    >
                        <CustomCheckBox
                            disabled={isResult}
                            checked={checked?.includes(item.id)}
                            color={baseColors.green.primary}
                        />

                        <View style={{ flex: 1, marginLeft: 5 }}>
                            <OpenSansText
                                defaultFontFamily={baseFontFamily.OpenSansRegular}
                                fontSize={12}
                                style={styles.checkBoxLabelGreen}
                            >
                                {item.label}
                            </OpenSansText>
                        </View>
                    </TouchableOpacity>
                ))}
            </View>

            {isResult && (
                <View style={{ marginTop: 10 }}>
                    <OpenSansText style={{ fontStyle: "italic", color: "green", fontWeight: "bold" }} fontSize={14}>
                        La bonne réponse :
                    </OpenSansText>

                    <Spacer height={10} />

                    <View>
                        {correctAnswer?.map((item) => (
                            <OpenSansText
                                key={item.id}
                                style={{ fontStyle: "italic", marginLeft: 10, marginBottom: 5 }}
                                fontSize={12}
                            >
                                . {item?.textResponse}
                            </OpenSansText>
                        ))}
                    </View>
                </View>
            )}
        </View>
    )
}

const styles = StyleSheet.create({
    checkBox: { flexDirection: "row", alignItems: "center", marginBottom: 20 }
})
